import type { ComponentProps } from "react";
import { Message, MessageDescription } from "../Message";

export function FormErrorsMessage({
  errors = [],
  ...props
}: { errors?: Array<string> } & ComponentProps<typeof Message>) {
  if (errors.length === 0) return null;

  return (
    <Message data-slot="error" type="error" {...props}>
      <MessageDescription>{errors.join("\n")}</MessageDescription>
    </Message>
  );
}
